export default __webpack_public_path__ + "static/media/outline-icons.ddae9b1b.woff";